import { useTranslation } from "@opendash/core";
import { _User } from "@opendash/plugin-parse/dist/types-generated";
import { Button, Drawer, Form, Input, Space } from "antd";
import Parse from "parse";
import React, { useContext, useState } from "react";
import { AgencyContext } from "../contexts/AgencyContext";
import { Agency } from "../js/parsegenerated";
import { TimeZoneSelect } from "./TimeZoneSelect";

export const AgencyUpdateDrawer = (props: {
  open: boolean;
  onOk: Function;
}) => {
  const t = useTranslation();
  const [form] = Form.useForm<{
    agency_id: string;
    agency_name: string;
    agency_url: string;
    agency_timezone: string;
    agency_lang: string;
    agency_phone: string;
    agency_fare_url: string;
    agency_email: string;
  }>();
  const state = useContext(AgencyContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedTimezone, setSelectedTimezone] = useState();

  const close = () => {
    props.onOk();
  };

  const save = () => {
    setLoading(true);
    form.validateFields().then(
      async () => {
        const value = await new Parse.Query(Agency).get(
          state.selectedAgency.id
        );

        if (value) {
          value.set("agency_id", form.getFieldValue("agency_id"));
          value.set("agency_name", form.getFieldValue("agency_name"));
          value.set("agency_url", form.getFieldValue("agency_url"));
          value.set("agency_timezone", form.getFieldValue("agency_timezone"));
          value.set("agency_lang", form.getFieldValue("agency_lang"));
          value.set("agency_phone", form.getFieldValue("agency_phone"));
          value.set("agency_fare_url", form.getFieldValue("agency_fare_url"));
          value.set("agency_email", form.getFieldValue("agency_email"));
          value.set("tenant", (Parse.User.current() as _User).get("tenant"));

          const saveresult = await value.save();

          props.onOk();
          form.resetFields();
          setLoading(false);
        }
      },
      () => {
        setLoading(false);
      }
    );
  };

  return (
    <>
      <Drawer
        title={t("gtfs:agency.update.headline")}
        placement={"right"}
        width={"50%"}
        onClose={() => close()}
        open={props.open}
        extra={
          <Space>
            <Button onClick={() => close()}>
              {t("gtfs:global.button.close_label")}
            </Button>
            <Button onClick={() => save()} loading={loading} type="primary">
              {t("gtfs:global.button.save_label")}
            </Button>
          </Space>
        }
      >
        <Form form={form} layout="vertical" autoComplete="off">
          <Form.Item
            label="ID"
            initialValue={
              state.selectedAgency && state.selectedAgency.get("agency_id")
            }
            name="agency_id"
            key="agency_id"
            rules={[
              {
                required: true,
                message: t("gtfs:agency.update.form.id.rules.required.message"),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Name"
            initialValue={
              state.selectedAgency && state.selectedAgency.get("agency_name")
            }
            name="agency_name"
            key="agency_name"
            rules={[
              {
                required: true,
                message: t(
                  "gtfs:aagency.update.form.name.rules.required.message"
                ),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="URL"
            initialValue={
              state.selectedAgency && state.selectedAgency.get("agency_url")
            }
            name="agency_url"
            key="agency_url"
            rules={[
              {
                required: true,
                message: t(
                  "gtfs:agency.update.form.url.rules.required.message"
                ),
              },
              {
                type: "url",
                message: t(
                  "gtfs:agency.update.form.fare_url.rules.type.message"
                ),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Timezone"
            initialValue={
              state.selectedAgency &&
              state.selectedAgency.get("agency_timezone")
            }
            name="agency_timezone"
            key="agency_timezone"
            rules={[
              {
                required: true,
                message: t(
                  "gtfs:agency.update.form.timezone.rules.required.message"
                ),
              },
            ]}
          >
            <TimeZoneSelect />
          </Form.Item>
          <Form.Item
            label="Language"
            initialValue={
              state.selectedAgency && state.selectedAgency.get("agency_lang")
            }
            name="agency_lang"
            key="agency_lang"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Phone"
            initialValue={
              state.selectedAgency && state.selectedAgency.get("agency_phone")
            }
            name="agency_phone"
            key="agency_phone"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Fare URL"
            initialValue={
              state.selectedAgency &&
              state.selectedAgency.get("agency_fare_url")
            }
            name="agency_fare_url"
            key="agency_fare_url"
            rules={[
              {
                required: false,
              },
              {
                type: "url",
                message: t(
                  "gtfs:agency.update.form.fare_url.rules.type.message"
                ),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="E-Mail"
            initialValue={
              state.selectedAgency && state.selectedAgency.get("agency_email")
            }
            name="agency_email"
            key="agency_email"
            rules={[
              {
                required: false,
              },
              {
                type: "email",
                message: t("gtfs:agency.update.form.email.rules.type.message"),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};
